import type { ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { DialogKey } from '#src/components/navigation/WithDialogs/index.tsx';
import { useOpenDialog } from '#src/hooks/navigation/useOpenDialog.ts';
import { isType } from '#src/lib/gql/index.ts';

import type { RewardConfigImage_anyRewardConfigInterface } from '../RewardConfigImage/__generated__/index.graphql.ts';

const messages = defineMessages({
  seePackDetails: {
    defaultMessage: 'See pack details',
  },
});

type Props = {
  anyRewardConfig: RewardConfigImage_anyRewardConfigInterface;
  children: ReactNode;
};

export const PackDetailsButton = ({ anyRewardConfig, children }: Props) => {
  const { formatMessage } = useIntl();
  const openDialog = useOpenDialog();

  const cardPackSlug = isType(anyRewardConfig, 'CardPacksRewardConfig')
    ? anyRewardConfig.cardPack?.slug
    : undefined;

  if (!cardPackSlug) {
    return <>{children}</>;
  }

  return (
    <ButtonBase
      aria-label={formatMessage(messages.seePackDetails)}
      onClick={() => openDialog(DialogKey.packDetails, cardPackSlug)}
    >
      {children}
    </ButtonBase>
  );
};
